export const PATHS_DDBB = {
  datosCuriosos: 'inicio/datosCuriosos',
  activeDatosCuriosos: 'inicio/activeDatosCuriosos',
  preguntas: 'preguntas',
  respuestas: 'respuestas',
  documentsLinks: 'documentos/links',
  temas: 'general/temas',
  temasOrden: 'general/ordenDeTemas',
};

export const PATHS_SCKT = {
  activeDatosCuriosos: 'datosCuriosos:active',
};
